export default "__VITE_PUBLIC_ASSET__a8d01a18__"